import { Component } from '@angular/core';
import { PagamentoUtils } from 'src/app/common/components/fascicolo/pagamenti-view/pagamento-utils';
import { Liquidato } from 'src/app/common/models/liquidato';
import { NumericOperationManager } from 'src/app/common/utils/numeric-operation-manager';


export abstract class ImportiComponent {

  sorteTot: number = 0;
  interessiTot: number = 0;
  rivalutazioneTot: number = 0;
  compensoTot: number = 0;
  speseGenTot: number = 0;
  speseLiquidateTot = 0;
  irapTot = 0;
  oneriRiflessiTot = 0;
  speseMarcheNotificaTot = 0;
  art96CPCTot = 0;
  f23Tot = 0;
  risarcimentoTot = 0;  
  speseLiteTot: number = 0;
  cpaTot: number = 0;
  ivaTot: number = 0;
  ritenutaAccontoTot: number = 0;
  speseRegistrazioneTot: number = 0;
  contributoUnificatoTot: number = 0;
  altroImportoTot: number = 0;

  calculate(el: Liquidato) {
    this.sorteTot += Number(el.importoLiquidato.importo) || 0;
    this.interessiTot += Number(el.importoLiquidato.interessi) || 0;
    this.rivalutazioneTot += Number(el.importoLiquidato.sanzioni) || 0;
    this.compensoTot += Number(el.costoGestioneLiquidato.compenso) || 0;
    this.speseLiquidateTot += Number(el.costoGestioneLiquidato.speseLiquidate) || 0;
    this.irapTot += el.costoGestioneLiquidato.irap ? Number(el.costoGestioneLiquidato.compenso)*(el.costoGestioneLiquidato.irap/100) : 0; 
    this.oneriRiflessiTot += el.costoGestioneLiquidato.oneriRiflessi ? Number(el.costoGestioneLiquidato.compenso)*(el.costoGestioneLiquidato.oneriRiflessi/100) : 0;
    this.speseMarcheNotificaTot += Number(el.costoGestioneLiquidato.speseMarcheNotifica) || 0;
    this.art96CPCTot += Number(el.costoGestioneLiquidato.art96CPC) || 0;
    this.f23Tot += Number(el.costoGestioneLiquidato.f23) || 0;
    this.risarcimentoTot += Number(el.costoGestioneLiquidato.risarcimento) || 0;
    this.speseGenTot += Number(el.costoGestioneLiquidato.speseGeneraliValore) || 0;
    this.cpaTot += el.costoGestioneLiquidato.cpa ? Number(el.costoGestioneLiquidato.compenso)*(el.costoGestioneLiquidato.cpa.valore/100) : 0;
    this.ivaTot += el.costoGestioneLiquidato.iva ? Number(el.costoGestioneLiquidato.compenso + (el.costoGestioneLiquidato.compenso)*(el.costoGestioneLiquidato.cpa.valore/100))*(el.costoGestioneLiquidato.iva.valore/100) : 0;
    this.ritenutaAccontoTot += el.costoGestioneLiquidato.flagRitenutaAcconto ? Number(el.costoGestioneLiquidato.compenso)*0.2 : 0;
    this.speseRegistrazioneTot += Number(el.altroImportoLiquidato.speseRegistrazione) || 0;
    this.contributoUnificatoTot += Number(el.altroImportoLiquidato.contributoUnificato) || 0;
    this.altroImportoTot += Number(el.altroImportoLiquidato.altroImporto) || 0;
    this.speseLiteTot = this.getTotaleSpeseDiLite();
}


  getTotaleSpeseDiLite(): number {
    return this.approssimaImporto(this.compensoTot) +
           this.approssimaImporto(this.speseLiquidateTot) +
           this.approssimaImporto(this.irapTot) +
           this.approssimaImporto(this.oneriRiflessiTot) +
           this.approssimaImporto(this.speseMarcheNotificaTot) +
           this.approssimaImporto(this.art96CPCTot) +
           this.approssimaImporto(this.f23Tot) +
           this.approssimaImporto(this.risarcimentoTot) +
           this.approssimaImporto(this.cpaTot) +
           this.approssimaImporto(this.ivaTot) +
           this.approssimaImporto(this.speseGenTot) -
           this.approssimaImporto(this.ritenutaAccontoTot);
  }

  approssimaImporto(importo): number {
    let num = Number(importo);
    return Math.trunc(100 * num) / 100;
  }

  approssimaTotale(importo):number{
    let num=Number(importo);
    return (Math.abs(num-Math.round(num))<0.1) ? Math.round(num) : num;
  }

  getBeneficiario(pagamenti, i) {
    let beneficiariAll = PagamentoUtils.getBeneficiariAllFromSezionePagamento(pagamenti);
    return beneficiariAll[i];
  }
  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args);
  }

  getDiff(a: string, b: string) {
    return NumericOperationManager.getDiff(a, b);
  }

  transformToThousands(a: string) {
    return NumericOperationManager.transformToThousands(a);
  }

  getSomma(valori: string[]) {
    let somma: string = NumericOperationManager.getSum(valori);
    return somma;
  }

  calcolaSomma(valori: string[]) {
    let sommaOttenuta: string = NumericOperationManager.getSum(valori);
    let segno = false;
    if (sommaOttenuta.substring(0, 1) === '-') {
      sommaOttenuta = sommaOttenuta.substring(1);
      segno = true;
    }
    let indexVirgola: number = sommaOttenuta.indexOf(',');
    if (indexVirgola === -1) {
      indexVirgola = sommaOttenuta.length;
    }
    indexVirgola = indexVirgola - 3;
    while (indexVirgola > 0) {
      sommaOttenuta = sommaOttenuta.substring(0, indexVirgola) + '.' + sommaOttenuta.substring(indexVirgola);
      indexVirgola = indexVirgola - 3;
    }
    if (segno) {
      sommaOttenuta = '-' + sommaOttenuta;
    }
    return sommaOttenuta;
  }
  

}
